export default "__VITE_ASSET__YaHDvXJN__"